<!-- //toolbar component wizard steps and left time indicator -->
<div *ngIf="currentStep && currentStep.stepId>0" class="d-none d-md-flex align-items-center text-center px-5 py-4 flex-wrap mt-2">
	<div *ngFor="let item of [1,2,3,4,5,6]" class="m-step-indicator-top rounded-circle" 
		[ngClass]="{
		'active':currentStep.stepId== item,
		'complete':isStepCompleted(item) && currentStep.stepId!= item,
		'reachable':isStepReachble(item)}"
		[routerLink]="getStepRouterLink(item-1)">
			<div class="py-2 m-step-label">{{'STEP-INDICATOR.STEP-'+ item | translate}}</div>
			<span *ngIf="currentStep.stepId == item">{{item}}</span>
			<i *ngIf="item !== currentStep.stepId && isStepCompleted(item)" class="fa fa-check" aria-hidden="true"></i>	
	</div>
</div>

<div *ngIf="currentStep && currentStep.stepId>0" class="d-md-none d-flex text-center px-4 justify-content-between">
	<div *ngFor="let item of [1,2,3,4,5,6]" class="m-step-indicator-bottom-wrapper" [ngClass]="{'m-active-border':currentStep.stepId== item}">
		<div class="m-step-indicator-bottom rounded-circle" 
		[ngClass]="{
			'active':currentStep.stepId== item,
			'complete':isStepCompleted(item) && currentStep.stepId!= item,
			'reachable':isStepReachble(item)}"
			routerLink="/questionnaire/{{statesKeys[item-1]}}/all">
			<div *ngIf="currentStep.stepId== item" class="m-step-label">{{'STEP-INDICATOR.STEP-'+ item | translate}}</div>
			<span *ngIf="!isStepCompleted(item)">{{item}}</span>
			<i *ngIf="item !== currentStep.stepId && isStepCompleted(item)" class="fa fa-check" aria-hidden="true"></i>	
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/step-indicator/step-indicator.component.html